import { cn, Icon, type TableColumn, Typography } from "@kyan/ui";
import { type ReactNode } from "react";

import { formatValue } from "#/utils/valueFormatters";

import { type GreekData, type Greeks } from "./GreeksTable.types";

export const columns: TableColumn<GreekData>[] = [
  {
    id: "symbol",
    maxWidth: "32px",
    cellClassName: "dark:bg-buttonFill bg-buttonBg grid w-8 place-items-center",
  },
  {
    id: "name",
    maxWidth: "115px",
  },
  {
    id: "value",
    minWidth: "65px",
    cell: (row) => {
      return (
        <Typography
          className={cn({ "min-w-16 text-right": row.value !== undefined })}
        >
          {row.value}
        </Typography>
      );
    },
  },
];

const greekConfig: Record<
  Greeks,
  { symbol: ReactNode; name: string; precision: number }
> = {
  delta: {
    symbol: <Icon size="xs" name="delta" />,
    name: "Delta",
    precision: 3,
  },
  gamma: {
    symbol: <Icon size="sm" name="gamma" />,
    name: "Gamma",
    precision: 5,
  },
  vega: {
    symbol: <Icon size="xs" name="vega" />,
    name: "Vega",
    precision: 2,
  },
  theta: {
    symbol: <Icon size="md" name="theta" />,
    name: "Theta",
    precision: 2,
  },
};

export const createGreeksData = (
  values: Partial<Record<Greeks, number>>,
): GreekData[] => {
  return Object.keys(greekConfig)
    .filter((greek) => values[greek as Greeks] !== undefined)
    .map((greek) => {
      const greekKey = greek as Greeks;
      const config = greekConfig[greekKey];
      return {
        id: greekKey,
        symbol: config.symbol,
        name: config.name,
        value: formatValue(values[greekKey] ?? 0, {
          precision: config.precision,
        }),
      };
    });
};
